import { Component } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../auth/auth.service';
import { Translation } from '../../providers/translation';
import { Topbar } from '../../providers/topbar';
import { PaymentService } from '../payment/payment.service';
import { ICredit } from '../../models/credit';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators/filter';
import { tap } from 'rxjs/operators/tap';
import { ISession } from '../../models/session';
import { CustomizationService } from '../customization/customization.service';
import { config } from 'process';

@Component({
  selector: 'app-topnavbar',
  templateUrl: './topnavbar.component.html',
  styleUrls: ['./topnavbar.component.scss']
})
export class TopnavbarComponent {
  public session: ISession = null;
  public accountConfig = {};
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    public translation: Translation,
    public topbar: Topbar,
    public paymentService: PaymentService,
    public customizationService: CustomizationService
  ) {}

  ngOnInit() {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          this.session = null;
          const { data } = this.route.snapshot.firstChild;
          if (data && data['data'] && this.isSession(data['data'])) {
            this.session = data['data'];
          }
        })
      )
      .subscribe(null);
      this.customizationService.getAccountConfig().subscribe(config => {
        this.accountConfig = config;
      });
  }

  logout() {
    this.authService.logout();
  }

  isSession(data) {
    return 'id' in data && 'name' in data && 'types' in data;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/topnavbar/topnavbar.component.ts